import React from 'react';
export const OnScreenArticleContext = React.createContext(undefined);
export const useOnScreenArticle = () => React.useContext(OnScreenArticleContext);
export function OnScreenArticle(props) {
    const store = useOnScreenArticle();
    return store(props);
}
